import React, { useEffect } from "react";
import pre23CollectionImages from "../js/database/database-pre23-collection";
import galleryImages from "../js/database/database-gallery.js";

import setFontColor from "../js/setFontColor";
import setBodyColor from "../js/setBodyColor";

import { SwiperSlide } from "swiper/react";

import MainPagesContainer from "../components/containers/MainPagesContainer";

const alt = "PRE23 collection";
const imgWidth = "1000";
const imgHeight = "1500";

const PRE23 = (props) => {
  //setFontColor({ color: "#7a7a7a" });
  setBodyColor({ color: "#ffffff" });

  /*  useEffect(() => {
    const images = document.querySelectorAll("img[data-src]");
    const options = {
      root: null,
      threshold: 0,
      rootMargin: "0px 0px 0px 0px",
    };

    const observer = new IntersectionObserver(function (entries, observer) {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }
        const img = entry.target;
        img.setAttribute("src", img.getAttribute("data-src"));
        img.removeAttribute("data-src");
        img.style.opacity = 0;
        img.style.filter = "blur(5px)";
        img.addEventListener("load", () => {
          setTimeout(() => {
            img.style.transition =
              "opacity 0.5s ease-in-out, filter 0.5s ease-in-out";
            img.style.opacity = 1;
            img.style.filter = "blur(0px)";
          }, 0);
        });
        observer.unobserve(img);
      });
    }, options);

    images.forEach((img) => {
      observer.observe(img);
    });
  }, []); */

  return (
    <MainPagesContainer
      pageTitle={alt}
      videoDisplay={{ display: "none" }}
      collectionsClassName={"circle"}
      PDFshouldHide={true}
    >
      {React.Children.toArray(
        pre23CollectionImages.map(({ srcJpeg, srcWebp, loading }) => (
          <SwiperSlide>
            <picture>
              <source srcSet={srcWebp} type="image/webp" />
              <img
                src={srcJpeg}
                width={imgWidth}
                height={imgHeight}
                alt={alt}
                loading="eager"
              />
            </picture>
          </SwiperSlide>
        ))
      )}
      {React.Children.toArray(
        galleryImages.map(({ srcJpeg, srcWebp, loading }) => (
          <SwiperSlide>
            <picture>
              <source srcSet={srcWebp} type="image/webp" />
              <img
                src={srcJpeg}
                width={imgWidth}
                height={imgHeight}
                alt={alt}
                loading="eager"
              />
            </picture>
          </SwiperSlide>
        ))
      )}
    </MainPagesContainer>
  );
};

export default PRE23;
